import React, { Fragment } from 'react';
const idSet = new Set();
function errorOnce(key, message) {
    if (idSet.has(key)) {
        return;
    }
    idSet.add(key);
    console.error(message);
}
export const Unknown = function Unknown(props) {
    errorOnce(props.id, `Unable to resolve component with id ${props.id}`);
    if (process.env.NODE_ENV === 'production') {
        return React.createElement(Fragment, null);
    }
    return React.createElement(Fragment, null, "UNKNOWN!!!");
};
